export default __webpack_public_path__ + "static/media/img1.66e905b3.png";